
    import { register } from "https://d1sh6n8scllmrv.cloudfront.net/wc/EnrollmentWebComponents.js";
    register();
  